//# sourceMappingURL=duration_.mjs.map
/// <reference types="./duration_.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $duration from "../../../gleam_time/gleam/time/duration.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Monday extends $CustomType {}
export const DayOfWeek$Monday = () => new Monday();
export const DayOfWeek$isMonday = (value) => value instanceof Monday;

export class Tuesday extends $CustomType {}
export const DayOfWeek$Tuesday = () => new Tuesday();
export const DayOfWeek$isTuesday = (value) => value instanceof Tuesday;

export class Wednesday extends $CustomType {}
export const DayOfWeek$Wednesday = () => new Wednesday();
export const DayOfWeek$isWednesday = (value) => value instanceof Wednesday;

export class Thursday extends $CustomType {}
export const DayOfWeek$Thursday = () => new Thursday();
export const DayOfWeek$isThursday = (value) => value instanceof Thursday;

export class Friday extends $CustomType {}
export const DayOfWeek$Friday = () => new Friday();
export const DayOfWeek$isFriday = (value) => value instanceof Friday;

export class Saturday extends $CustomType {}
export const DayOfWeek$Saturday = () => new Saturday();
export const DayOfWeek$isSaturday = (value) => value instanceof Saturday;

export class Sunday extends $CustomType {}
export const DayOfWeek$Sunday = () => new Sunday();
export const DayOfWeek$isSunday = (value) => value instanceof Sunday;

export const days_of_week_from_monday = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Monday(),
  /* @__PURE__ */ new Tuesday(),
  /* @__PURE__ */ new Wednesday(),
  /* @__PURE__ */ new Thursday(),
  /* @__PURE__ */ new Friday(),
  /* @__PURE__ */ new Saturday(),
  /* @__PURE__ */ new Sunday(),
]);

/**
 * Convert a duration into the corresponding number of units. Use a simple
 * algorithm consisting in dividing by the number of seconds during the period ç
 * of time. It does not take into account leap seconds or variations of
 * days in a month.
 */
export function to(duration, unit) {
  let duration$1 = $duration.to_seconds(duration);
  if (unit instanceof $duration.Nanosecond) {
    return duration$1 * 1000000000.0;
  } else if (unit instanceof $duration.Microsecond) {
    return duration$1 * 1000000.0;
  } else if (unit instanceof $duration.Millisecond) {
    return duration$1 * 1000.0;
  } else if (unit instanceof $duration.Second) {
    return duration$1;
  } else if (unit instanceof $duration.Minute) {
    return duration$1 / 60.0;
  } else if (unit instanceof $duration.Hour) {
    return duration$1 / 3600.0;
  } else if (unit instanceof $duration.Day) {
    return duration$1 / 86400.0;
  } else if (unit instanceof $duration.Week) {
    return duration$1 * 604800.0;
  } else if (unit instanceof $duration.Month) {
    return duration$1 / 2629800.0;
  } else {
    return duration$1 / 31557600.0;
  }
}

/**
 * Convert a duration into the corresponding number of units. Use a simple
 * algorithm consisting in rounding the data, after dividing by the number of
 * seconds during the period of time. It does not take into account
 * leap seconds or variations of days in a month.
 */
export function blur_to(duration, unit) {
  let duration$1 = to(duration, unit);
  return $float.round(duration$1);
}

/**
 * Create a duration of a number of days.
 */
export function days(n) {
  return $duration.hours(24 * n);
}

/**
 * Create a duration of a number of weeks.
 */
export function weeks(n) {
  return $duration.hours(24 * 7 * n);
}

/**
 * Create a duration of a number of months.
 * Every month is considered to be 30 days long.
 * Do not use that function if you need precise computations.
 */
export function months(n) {
  return $duration.hours(24 * 30 * n);
}

/**
 * Create a duration of a number of years.
 * Every year is considered to be 365 days long.
 * Do not use that function if you need precise computations.
 */
export function years(n) {
  return $duration.hours(24 * 365 * n);
}

/**
 * Negate a duration.
 */
export function negate(duration_) {
  return $duration.difference(duration_, $duration.seconds(0));
}

export function unit_to_seconds(unit) {
  if (unit instanceof $duration.Nanosecond) {
    return 0;
  } else if (unit instanceof $duration.Microsecond) {
    return 0;
  } else if (unit instanceof $duration.Millisecond) {
    return 0;
  } else if (unit instanceof $duration.Second) {
    return 1;
  } else if (unit instanceof $duration.Minute) {
    return 60;
  } else if (unit instanceof $duration.Hour) {
    return 3600;
  } else if (unit instanceof $duration.Day) {
    return 86_400;
  } else if (unit instanceof $duration.Week) {
    return 604_800;
  } else if (unit instanceof $duration.Month) {
    return 2_629_800;
  } else {
    return 31_557_600;
  }
}

/**
 * Encode a unit in JSON. Decode it with [`unit_decoder()`](#unit_decoder).
 */
export function encode_unit(unit) {
  if (unit instanceof $duration.Nanosecond) {
    return $json.string("nanosecond");
  } else if (unit instanceof $duration.Microsecond) {
    return $json.string("microsecond");
  } else if (unit instanceof $duration.Millisecond) {
    return $json.string("millisecond");
  } else if (unit instanceof $duration.Second) {
    return $json.string("second");
  } else if (unit instanceof $duration.Minute) {
    return $json.string("minute");
  } else if (unit instanceof $duration.Hour) {
    return $json.string("hour");
  } else if (unit instanceof $duration.Day) {
    return $json.string("day");
  } else if (unit instanceof $duration.Week) {
    return $json.string("week");
  } else if (unit instanceof $duration.Month) {
    return $json.string("month");
  } else {
    return $json.string("year");
  }
}

/**
 * Decode a data in `duration.Unit`. You can convert a unit in JSON with
 * [`encode_unit()`](#encode_unit).
 */
export function unit_decoder() {
  return $decode.then$(
    $decode.string,
    (period) => {
      if (period === "day") {
        return $decode.success(new $duration.Day());
      } else if (period === "hour") {
        return $decode.success(new $duration.Hour());
      } else if (period === "month") {
        return $decode.success(new $duration.Month());
      } else if (period === "week") {
        return $decode.success(new $duration.Week());
      } else if (period === "year") {
        return $decode.success(new $duration.Year());
      } else if (period === "microsecond") {
        return $decode.success(new $duration.Microsecond());
      } else if (period === "millisecond") {
        return $decode.success(new $duration.Millisecond());
      } else if (period === "minute") {
        return $decode.success(new $duration.Minute());
      } else if (period === "nanosecond") {
        return $decode.success(new $duration.Nanosecond());
      } else if (period === "second") {
        return $decode.success(new $duration.Second());
      } else {
        return $decode.failure(new $duration.Year(), "Unit");
      }
    },
  );
}

export function day_to_int(day) {
  if (day instanceof Monday) {
    return 0;
  } else if (day instanceof Tuesday) {
    return 1;
  } else if (day instanceof Wednesday) {
    return 2;
  } else if (day instanceof Thursday) {
    return 3;
  } else if (day instanceof Friday) {
    return 4;
  } else if (day instanceof Saturday) {
    return 5;
  } else {
    return 6;
  }
}

export function int_to_day(day, fallback) {
  if (day === 0) {
    return new Monday();
  } else if (day === 1) {
    return new Tuesday();
  } else if (day === 2) {
    return new Wednesday();
  } else if (day === 3) {
    return new Thursday();
  } else if (day === 4) {
    return new Friday();
  } else if (day === 5) {
    return new Saturday();
  } else if (day === 6) {
    return new Sunday();
  } else {
    return fallback;
  }
}

export function day_to_string(day) {
  if (day instanceof Monday) {
    return "Monday";
  } else if (day instanceof Tuesday) {
    return "Tuesday";
  } else if (day instanceof Wednesday) {
    return "Wednesday";
  } else if (day instanceof Thursday) {
    return "Thursday";
  } else if (day instanceof Friday) {
    return "Friday";
  } else if (day instanceof Saturday) {
    return "Saturday";
  } else {
    return "Sunday";
  }
}
